import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../context/ProductContext";

import { Helmet } from "react-helmet-async";
import BrandsMain from "../layouts/main/BrandsMain";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const Brands = () => {
  const { t, i18n } = useTranslation();
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    loadProducts();
  }, [i18n.language]);

  const seoData = {
    en: {
      title: "Top Nicotine Pouch Brands for Tobacco Shops – B2B SnusCo",
      description:
        "Discover our premium selection of nicotine pouch brands, trusted by tobacco shops across Europe for consistent quality, rich flavor variety, and bulk availability. Order wholesale from B2B SnusCo with fast, reliable delivery!",
      keywords:
        "snusco, b2b snusco, wholesale nicotine pouch brands, bulk nicotine pouches, tobacco shop supplies, nicotine pouch brands Europe",
      url: "https://b2b.snusco.at/en/brands",
      images: ["https://b2b.snusco.at/assets/brands-category-image.jpg"],
    },
    de: {
      title: "Top-Marken für Nikotintaschen – Großhandel B2B SnusCo GmbH",
      description:
        "Entdecken Sie unsere Premium-Auswahl an Nikotintaschen-Marken, geschätzt von Tabakgeschäften in ganz Europa für gleichbleibende Qualität, reichhaltige Aromen und große Verfügbarkeit. Jetzt im Großhandel bei B2B SnusCo bestellen!",
      keywords:
        "snusco, b2b snusco, Großhandel Nikotintaschen-Marken, Bulk Nikotintaschen, Tabakladenbedarf, Nikotintaschen-Marken Europa",
      url: "https://b2b.snusco.at/de/marken",
      images: ["https://b2b.snusco.at/assets/brands-category-image.jpg"],
    },
  };

  const currentSeo = seoData[i18n.language] || seoData.en;

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>{currentSeo.title}</title>

        {/* Meta Description */}
        <meta name="description" content={currentSeo.description} />

        {/* Meta Keywords */}
        <meta name="keywords" content={currentSeo.keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={currentSeo.ogTitle} />
        <meta property="og:description" content={currentSeo.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentSeo.url} />
        <meta property="og:image" content={currentSeo.image} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentSeo.twitterTitle} />
        <meta
          name="twitter:description"
          content={currentSeo.twitterDescription}
        />
        <meta name="twitter:image" content={currentSeo.image} />

        {/* Canonical Link */}
        <link rel="canonical" href={currentSeo.url} />

        {/* Additional Meta Tags */}
        <meta property="og:locale" content={currentSeo.locale} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <BrandsMain />
    </>
  );
};

export default Brands;
